/**
 * Configuration et données pour le composant Hero
 */

// Statistiques affichées dans la section Hero
export const statistics = [
  { value: 10, label: "Ans d'expérience" },
  { value: 50, label: "Projets réalisés" },
  { value: 2000, label: "Personnes formées" }
];

// Services mis en avant dans la section Hero
export const services = [
  {
    id: "web-dev",
    title: "Accompagnement IA",
    subtitle: "Diagnostic, cas d’usage, choix d’outils",
    color: "#ed4c67",
    icon: `<path fill-rule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />`
  },
  {
    id: "ai",
    title: "Formations IA",
    subtitle: "Formation, adoption et gouvernance IA",
    color: "#3498db",
    icon: `<path fill-rule="evenodd" d="M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z" clip-rule="evenodd" />`
  },
  {
    id: "formation",
    title: "Stratégie Numérique",
    subtitle: "Accompagnement à la transformation",
    color: "#e67e22",
    icon: `<path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />`
  },
  {
    id: "consulting",
    title: "RGPD",
    subtitle: "Audit de conformité et cartographie des données",
    color: "#1abc9c",
    icon: `<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />`
  }
];

// Textes principaux
export const mainTexts = {
  title: {
    first: "Transformez votre",
    highlight: `<span class="text-gradient-animate font-bold">entreprise</span>`,
    last: "avec le numérique"
  },
  description: `
    <span class="font-medium text-won-teal">Accompagnement digital </span>personnalisé,
    formation à l'<span class="font-medium text-won-pink">IA</span>,
    expertise en <span class="font-medium text-won-blue">développement web</span><br><br>
    <span class="font-medium text-won-blue">IA, digital, formation :</span> votre avenir commence ici.
  `,
  ctaButtons: {
    primary: {
      text: "Contactez-nous",
      href: "contact.html"
    },
    secondary: {
      text: "Découvrir nos services",
      href: "#services"
    }
  },
  badge: "Transformez votre business avec l'IA"
};

// Configuration d'animation
export const animationConfig = {
  counterIncrementTime: 50,
  counterSteps: 30,
  startDelay: 500
};
